<script>
import CommonTableComponent from "@/components/table.vue";

export default {
  props: {
    transportContractVendors: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    CommonTableComponent
  },
  computed: {
    headers() {
      return [
        {
          text: "区間",
          value: "index",
          sortable: false
        },
        {
          text: "運送業者",
          value: "vendor_name",
          sortable: false
        },
        {
          text: "積卸先",
          value: "vendor_site_name",
          sortable: false
        },
        {
          text: "住所",
          value: "vendor_site_address",
          sortable: false
        },
        {
          text: "運送方法",
          value: "transport_constracts",
          sortable: false
        }
      ];
    }
  }
};
</script>

<template>
  <div class="gap-4">
    <div class="custom-input mb-1">
      <label class="white-space-pre">運送業者</label>
    </div>
    <div class="w-100">
      <CommonTableComponent :height-class="`table-wrapper-500`">
        <thead class="table-light">
          <tr>
            <th
              :style="`width: ${item.width}`"
              v-for="(item, index) in headers"
              :key="index"
            >
              <span>
                {{ item.text }}
              </span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="index in 5"
            :key="index"
            v-if="
              transportContractVendors &&
                (transportContractVendors[`vendor_id_section${index}`] ||
                  transportContractVendors[`vendor_site_id_section${index}`])
            "
          >
            <td>{{ index }}</td>
            <td>
              {{
                transportContractVendors[`vendor_id_section${index}`] &&
                  transportContractVendors[`vendor_id_section${index}`].name
              }}
            </td>
            <td>
              {{
                transportContractVendors[`vendor_site_id_section${index}`] &&
                  transportContractVendors[`vendor_site_id_section${index}`]
                    .name
              }}
            </td>
            <td>
              {{
                transportContractVendors[`vendor_site_id_section${index}`] &&
                  (
                    transportContractVendors[`vendor_site_id_section${index}`]
                      .address_1 +
                    transportContractVendors[`vendor_site_id_section${index}`]
                      .address_2 +
                    transportContractVendors[`vendor_site_id_section${index}`]
                      .address_3 +
                    transportContractVendors[`vendor_site_id_section${index}`]
                      .address_4
                  ).replace("null", "")
              }}
            </td>
            <td>
              {{
                transportContractVendors[`zz_jw_transport_method${index}`] &&
                  transportContractVendors[`zz_jw_transport_method${index}`]
                    .jw_transport_method
              }}
            </td>
          </tr>
        </tbody>
      </CommonTableComponent>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
